import abbreviateNumber from '@source/utils/abbreviateNumber';
import Image from 'next/legacy/image';
import mojs from '@mojs/core';
import * as S from '../../styles';
import { useEffect, useRef } from 'react';

type Props = {
  displayUserClaps: boolean;
  userClaps: number;
  totalClaps?: number;
  concentrationClaps: number;
  increment: () => void;
  timeoutClear: () => void;
  hideTotalCount?: boolean;
  isBeingHeld?: boolean;
};

// Declaration of the burst object
const burstObj = {
  className: 'BurstExample',
  radius: { 25: 75 },
  count: 10,
  top: 0,
  left: 0,
  duration: 2000,
  children: {
    shape: ['circle', 'polygon'],
    fill: ['#7cb8f8', '#eee', '#ddd', '#1e39e9', '#f6d540'],
    angle: { 0: 10 },
    // rand string - generates random value for every child rand( min, max )
    degreeShift: 'rand(-360, 360)',
    // stagger string( start, step ) for every child
    delay: 'stagger(0, 25)',

    isSwirl: true, // Creates a swirl
    swirlSize: 10, // defines amplitude of the sine
    swirlFrequency: 'rand( 3, 6 )', // defines frequency of the sine
    pathScale: 'rand( .1, 1 )', // defines how much the total path length should be scaled
    direction: 'rand( 1, -1 )' // direction of the sine could be 1 or -1
  }
};

// Create a burst object pooling array
// read more at: https://codesandbox.io/s/mojs-react-example-kbikb?file=/src/Button.js:997-1180
const buttonBurstsPool = [
  new mojs.Burst(burstObj),
  new mojs.Burst(burstObj),
  new mojs.Burst(burstObj),
  new mojs.Burst(burstObj),
  new mojs.Burst(burstObj),
  new mojs.Burst(burstObj)
];

let burstIndex = 0;

const ClapsButton: React.FC<Props> = ({
  displayUserClaps,
  userClaps,
  totalClaps,
  concentrationClaps,
  increment,
  timeoutClear,
  hideTotalCount,
  isBeingHeld
}): JSX.Element => {
  const userClapClasses = () => {
    if (displayUserClaps) {
      return 'active';
    }
    if (concentrationClaps) {
      return 'activeConcentration';
    }
    return '';
  };

  const burstAnimation = e => {
    buttonBurstsPool[burstIndex]
      .tune({ x: e.pageX, y: e.pageY })
      .generate()
      .replay();
    burstIndex = burstIndex >= buttonBurstsPool.length - 1 ? 0 : burstIndex + 1;
  };

  const clapButtonRef = useRef<any>(null);

  useEffect(() => {
    if (isBeingHeld && clapButtonRef?.current) {
      setTimeout(() => burstAnimation(clapButtonRef?.current), 450);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [concentrationClaps]);

  return (
    <S.ClapsButton
      className={displayUserClaps ? 'activeClapImage' : ''}
      onMouseUp={timeoutClear}
      onMouseDown={e => {
        burstAnimation(e);
        clapButtonRef!.current = e;
        increment();
      }}
    >
      <Image
        src={userClaps ? '/icons/claps.svg' : '/icons/claps_grey.svg'}
        width={24}
        height={20}
        alt="Claps"
      />

      <S.UserClaps
        concentrationClaps={concentrationClaps}
        className={userClapClasses()}
      >
        +{userClaps}
      </S.UserClaps>

      {!hideTotalCount && (
        <S.ClapsCount claps={userClaps}>
          {abbreviateNumber(totalClaps, 0)}
        </S.ClapsCount>
      )}
    </S.ClapsButton>
  );
};

export default ClapsButton;
